module.exports = __webpack_public_path__ + "img/dw_5.87840855.png";